<script setup>
import { ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    default: () => [],
  },
  activeValues: {
    type: Array,
    default: () => [],
  },
  valueField: {
    type: String,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);
const isOpen = ref(false);

function toggleOpen() {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <div class="flex! flex-col! gap-y-3.5! self-start!">
    <div class="flex! items-center! gap-x-2.5! font-ibm-plex-mono!">
      <h4
        class="max-w-40! text-base! leading-tight! text-blue!"
        :class="props.activeValues.length > 0 ? 'font-semibold!' : 'font-medium!'"
      >
        {{ title }}
        <span v-if="props.activeValues.length > 0">[{{ props.activeValues.length }}]</span>
      </h4>
      <button
        type="button"
        class="w-5! h-5! text-2xl! leading-none! flex! items-center! justify-center!"
        :class="[
          isOpen ? 'bg-blue! text-white! border! border-blue!' : 'border! border-blue! text-blue!',
          props.activeValues.length > 0 ? 'border-2! font-bold!' : ''
        ]"
        @click="toggleOpen"
      >
        {{ isOpen ? '-' : '+' }}
      </button>
    </div>

    <div v-if="isOpen && props.isLoading" class="min-h-10! flex! items-center! justify-center!">
      <span class="w-8! h-8! border-2! border-blue! border-t-transparent! rounded-full! animate-spin!"></span>
    </div>

    <div v-else-if="isOpen" class="flex! flex-wrap! items-center! gap-3 lg:gap-3.5!">
      <button
        v-for="item in items"
        :key="item.id"
        class="font-ibm-plex-mono! font-normal! text-base! leading-tight! px-3.5! py-0.5! border! rounded-full!"
        :class="props.activeValues.includes(item[props.valueField]) ? 'bg-blue! border-blue! text-white!' : 'border-black! text-black!'"
        :disabled="props.isLoading"
        @click="emit('toggle', item[props.valueField])"
      >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>